<template>
  <Card class="card regulatory-organization" head title="业务指南" :more="false">
    <div class="organization mt-6 mb-6" v-for="item in organizations" :key="item.id">
      <div class="name" :style="{backgroundImage:'url('+item.src+')'}" @click="itemOnClick(item)"><span>{{item.name}}</span></div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/UI/Card'
import manual1 from '@/assets/images/manual-1.png'
import manual2 from '@/assets/images/manual-2.png'
export default {
  name: 'RegulatoryOrganization',
  components: {
    Card
  },
  data () {
    return {
      organizations: [{
        id: 0,
        name: '招标流程',
        src: manual1,
        path: '/manual?#tender-process-1'
      }, {
        id: 1,
        name: '操作指南',
        src: manual2,
        path: '/manual#instructions-1'
      }]
    }
  },
  methods: {
    itemOnClick (item) {
      this.$router.push(item.path)
    }
  }
}
</script>

<style lang="scss" scoped>
.regulatory-organization {
  .organization {
    font-size: 14px;
    .name {
      font-weight: 500;
      color: #000;
      margin-bottom: 2px;
      background-size: cover;
      color: #fff;
      padding: 60px 30px;
      font-size: 20px;
      @media ( max-width: 1264px ) {
        padding-top: 30px;
        padding-bottom: 30px;
      }
      cursor: pointer;
      span {
        border-bottom: 1px solid #fff;
        padding-bottom: 5px;
      }
    }
    .address {
      color: rgba(0, 0, 0, 0.5)
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
